import { Component, ElementRef, ViewChild, Input, OnInit, OnDestroy, Renderer, NgZone } from '@angular/core';

import { AuthService } from '../../auth/auth.service';
import { UserService } from '../../services/user.service';
import { ModalService } from '../modal/modal.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ProfileComponent } from '../../shared/modal/profile/profile.component';
import { GlobalService } from '../../services/global.service';
import { User } from '../../models/user';

@Component({
    selector: 'app-topnav',
    templateUrl: './topnav.component.html',
    styleUrls: ['./topnav.component.css']
})

export class TopnavComponent implements OnInit, OnDestroy {
    @Input('notifications') notifications: number;

    public profileImage = "";
    public logoImage = "";

    @ViewChild('searchInput') searchInput: ElementRef;
    @ViewChild('searchIconContainer') searchIconContainer: ElementRef;
    @ViewChild('searchIcon') searchIcon: ElementRef;

    @ViewChild('notificationContainer') notificationContainer: ElementRef;
    @ViewChild('notificationIcon') notificationIcon: ElementRef;
    @ViewChild('notificationCount') notificationCount: ElementRef;

    @ViewChild('userProfile') userProfile: ElementRef;
    @ViewChild('userDropDown') userDropDown: ElementRef;

    user: User
    hamburgerVisible: boolean;

    constructor(private router: Router, private dialog: MatDialog, private renderer: Renderer, public auth: AuthService, private modalService: ModalService, private userService: UserService, private global: GlobalService, private ngZone: NgZone) {
        modalService.modal$.subscribe((modal) => {
            if (modal.modalName == 'edit-profileClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
                this.profileImage = localStorage.getItem('profilePhotoPath') !== 'null' ? this.global.assetURL + localStorage.getItem('profilePhotoPath') : 'https://web234.hvsfinancial.com/portal/assets/images/users/anon_user.png';
                this.logoImage = localStorage.getItem('logoPhotoPath') !== 'null' ? this.global.assetURL + localStorage.getItem('logoPhotoPath') : 'https://web234.hvsfinancial.com/portal/assets/images/temp/logo.png';
                this.user.firstName = localStorage.getItem('firstName');
                this.user.lastName = localStorage.getItem('lastName');
                // console.log(this.user);
            }
        });

        this.notifications = 5;

        window.onresize = () => { // Detect screen size and resizing
            ngZone.run(() => {
                if (window.innerWidth < 900) {
                    this.hamburgerVisible = true;
                } else {
                    this.hamburgerVisible = false;
                }
                localStorage.setItem('hamburgerVisible', JSON.stringify(this.hamburgerVisible));
            })
        }
    }

    ngOnInit() {
        this.user = this.userService.getUserInformation();
        this.profileImage = localStorage.getItem('profilePhotoPath') !== 'null' ? this.global.assetURL + localStorage.getItem('profilePhotoPath') : 'https://web234.hvsfinancial.com/portal/assets/images/users/anon_user.png';
        this.logoImage = localStorage.getItem('logoPhotoPath') !== 'null' ? this.global.assetURL + localStorage.getItem('logoPhotoPath') : 'https://web234.hvsfinancial.com/portal/assets/images/temp/logo.png';
        this.hamburgerVisible = window.innerWidth < 900 ? true : false;
        localStorage.setItem('hamburgerVisible', JSON.stringify(this.hamburgerVisible));
    }

    searchFocus() {
        this.searchInput.nativeElement.placeholder = "";
        this.searchInput.nativeElement.style.color = "#555";
        this.searchIcon.nativeElement.style.color = "#555";
    }

    searchFocusOut() {
        this.searchInput.nativeElement.style.color = "#e0e0e0";
        this.searchIcon.nativeElement.style.color = "#555";
    }

    handleNotificationClick(e) {

    }

    handleSearch(e) {

    }

    handleUserNav(e) {
        if (this.userDropDown.nativeElement.classList.contains('dropdown-visible')) {
            this.renderer.setElementClass(this.userDropDown.nativeElement, 'dropdown-visible', null);
            this.renderer.setElementClass(this.userDropDown.nativeElement, 'dropdown-hidden', true);
        } else if (this.userDropDown.nativeElement.classList.contains('dropdown-hidden')) {
            this.renderer.setElementClass(this.userDropDown.nativeElement, 'dropdown-hidden', null);
            this.renderer.setElementClass(this.userDropDown.nativeElement, 'dropdown-visible', true);
        } else {
            this.renderer.setElementClass(this.userDropDown.nativeElement, 'dropdown-visible', true);
        }
    }

    handleContactUsModal(e) {
        this.modalService.add('contact-support', { ID: Number(localStorage.getItem("userId")) });
    }

    handleEditProfileModal(e) {
        const dialogRef = this.dialog.open(ProfileComponent, {
            data: this.user//{ }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.profileImage = localStorage.getItem('profilePhotoPath') !== 'null' ? this.global.assetURL + localStorage.getItem('profilePhotoPath') : 'https://web234.hvsfinancial.com/portal/assets/images/users/anon_user.png';
            this.user = this.userService.getUserInformation();
          });
    }

    handleSettingsModal(e) {
        this.modalService.add('settings', { ID: Number(localStorage.getItem("userId")) });
    }

    logout() {
        this.auth.logout();
        this.router.navigateByUrl('login');
    }

    ngOnDestroy() {
    }

}
